export default "3896397a0aa70a67.svg"